export default __webpack_public_path__ + "969d2e4792799e51ac9b1ed00e784bef.png";